import { render } from "./CoastHeader.vue?vue&type=template&id=edd046bc"
import script from "./CoastHeader.vue?vue&type=script&lang=js"
export * from "./CoastHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/coastal-watchers-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__